module.exports = __webpack_public_path__ + "static/LA-ac32ae092d471d4d532a6cc06b203e9b.svg";